import React from "react";
import styles from "./ProductSliderSkeleton.module.css";

interface ProductSliderSkeletonProps {
  itemCount?: number;
}

const ProductSliderSkeleton: React.FC<ProductSliderSkeletonProps> = ({
  itemCount = 6,
}) => {
  return (
    <div className={styles.sliderSkeletonContainer}>
      <div className={styles.headerSkeleton}>
        <div className={styles.titleSkeleton}></div>
        <div className={styles.subtitleSkeleton}></div>
      </div>

      <div className={styles.productsContainerSkeleton}>
        {[...Array(itemCount)].map((_, index) => (
          <div key={index} className={styles.productCardSkeleton}>
            <div className={styles.productImageSkeleton}></div>
            <div className={styles.productContentSkeleton}>
              <div className={styles.productPriceSkeleton}></div>
              <div className={styles.productDeliverySkeleton}></div>
              <div className={styles.productNameSkeleton}></div>
              <div className={styles.productSwatchesSkeleton}>
                {[...Array(3)].map((_, swatchIdx) => (
                  <div
                    key={swatchIdx}
                    className={styles.colorSwatchSkeleton}
                  ></div>
                ))}
              </div>
            </div>
            <div className={styles.productButtonSkeleton}></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductSliderSkeleton;
